import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { message } from 'antd'

import JobOfferModel from './JobOfferModel'
import JobApplicantNotes from './JobApplicantNotes'
import JobApplicantResume from './JobApplicantResume'
import JobApplicantInfoCard from './JobApplicantInfoCard'
import JobApplicantPersonalDetails from './JobApplicantPersonalDetails'

// store
import { profileState } from '../../profile/profile.slice'
import { apiUpdateJobApplicationStatus } from '../store/jobApplicant.service'
import {
    changePage,
    getJobApplicantListByStatus,
    getStatusWiseCount,
} from '../store/jobApplicant.slice'

import styles from '../jobApplications.module.css'

const initialJobApplicationState = {
    status: null,
    jobOfferModalOpen: false,
    jobOfferModalData: null,
}

const JobApplicantDetails = ({
    state,
    setState,
    canEdit = true,
}) => {
    const dispatch = useDispatch()
    const params = useParams()

    const [JobApplicationState, setJobApplicationState] = useState(
        initialJobApplicationState
    )

    const { profileData } = useSelector(profileState)

    useEffect(() => {
        if (profileData) {
            setJobApplicationState((prevState) => ({
                ...prevState,
                status: profileData?.data?.status,
            }))
        }
    }, [profileData])

    const handleUpdateJobApplicationStatus = async (event) => {
        if (!canEdit) return
        try {
            // if (event !== 'offered') {
            const updateRes = await apiUpdateJobApplicationStatus({
                candidateId: state?.selectedApplicantData?.candidateId,
                status: event,
                jobId: params?.id,
            })

            if (updateRes?.data?.success) {
                dispatch(getStatusWiseCount({ jobId: params.id }))
                dispatch(
                    changePage({
                        currentPage: 1,
                        skip: 0,
                        pageLimit: 15,
                    })
                )
                dispatch(
                    getJobApplicantListByStatus({
                        skip: 0,
                        limit: 15,
                        filter: {
                            status: state?.jobStatus || 'matches',
                            job: params.id,
                        },
                    })
                )
                setJobApplicationState((prevState) => ({
                    ...prevState,
                    status: event,
                }))
                message.success('Job Application status updated successfully')
            }
            // }
            // else {
            //     setJobApplicationState((prevState) => ({
            //         ...prevState,
            //         status: event,
            //         jobOfferModalOpen: true,
            //     }))
            // }
        } catch (error) {
            console.log(error)
        }
    }

    const handleViewAndUpdateResume = () => {
        setState((prevState) => ({
            ...prevState,
            jobApplicantResumeDrawer: true,
        }))
    }

    const handleViewNotes = () => {
        setState((prevState) => ({
            ...prevState,
            jobApplicantNotesDrawer: true,
        }))
    }

    return (
        <>
            <div className={styles.detailStack}>
                <JobApplicantInfoCard
                    state={state}
                    setState={setState}
                    handleUpdateJobApplicationStatus={
                        canEdit ? handleUpdateJobApplicationStatus : null
                    }
                    JobApplicationState={JobApplicationState}
                    handleViewAndUpdateResume={handleViewAndUpdateResume}
                    handleViewNotes={handleViewNotes}
                />

                <JobApplicantPersonalDetails />
            </div>

            {canEdit ? (
                <JobOfferModel
                    state={JobApplicationState}
                    setState={setJobApplicationState}
                />
            ) : null}

            <JobApplicantResume
                state={state}
                setState={setState}
                canEdit={canEdit}
            />

            <JobApplicantNotes
                state={state}
                setState={setState}
                canEdit={canEdit}
            />
        </>
    )
}

export default JobApplicantDetails
